import React, { useCallback, useMemo, useState } from "react";
import { Button, Tag } from "antd";
import { useAgentsStore } from "../../../../../../../../../../store/agents.store";
import {
    selectDraftLicensedStates,
    selectIsScopeDirty,
} from "../../../../../../../../../../store/agentDetail/agentDetailSelectors";
import { AgentDetailSectionEnum } from "../../../../../../../../../../agentDetail.model";
import { AGENT_LICENSED_STATES_SAVE_SCOPE } from "../../../../../../../../../../agents.constants";
import { Footer } from "../../../footer/footer.index";
import { EditState } from "./editState/editState.index";
import styles from "./licensedStates.module.css";
import { RoundApproveIcon } from "../../../../../../../../../../../../Components/Icons/roundApproveIcon";

export const LicensedStates = () => {
    const [isEditStateOpen, setIsEditStateOpen] = useState(false);
    const licensedStates = useAgentsStore(selectDraftLicensedStates);
    const isLicensedStatesDirty = useAgentsStore(selectIsScopeDirty(AGENT_LICENSED_STATES_SAVE_SCOPE));
    const updateDraftField = useAgentsStore((state) => state.updateDraftField);
    const licensedStatesCount = licensedStates.length;

    const sortedLicensedStates = useMemo(
        () => [...licensedStates].sort((a, b) => (a.stateName ?? '').localeCompare(b.stateName ?? '')),
        [licensedStates]
    );

    const handleRemoveState = useCallback(
        (stateToRemove: number) => {
            const nextStates = licensedStates.filter((state) => state.stateId !== stateToRemove);
            updateDraftField(
                AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION,
                "licensedStates",
                nextStates
            );
        },
        [licensedStates, updateDraftField]
    );

    return (
        <div className={styles.outerCtn}>
            <div className={styles.headerCtn}>
                <div className={styles.iconCtn}>
                    <RoundApproveIcon width={20} height={20} fillColor="#fff" />
                </div>
                <div className={styles.contentCtn}>
                    <h2 className={styles.title}>Licensed States</h2>
                    { licensedStatesCount > 0 ? (
                        <h6 className={styles.description}>{licensedStatesCount} states active</h6>
                    ) : (
                        <h6 className={styles.description}>No states active</h6>
                    )}
                </div>
                <div className={styles.editBtnCtn}>
                    <Button
                        variant="outlined"
                        color="primary"
                        className={styles.editBtn}
                        onClick={() => setIsEditStateOpen(true)}
                    >
                        Edit Licensed States
                    </Button>
                </div>
            </div>
            {sortedLicensedStates.length > 0 && (
                <div className={styles.statesCtn}>
                    {sortedLicensedStates.map((state) => (
                        <Tag
                            key={state.stateId}
                            closeIcon
                            onClose={(event) => {
                                event.preventDefault();
                                handleRemoveState(state.stateId);
                            }}
                            className={styles.tagRoot}
                        >
                            <span className={styles.tagContent}>{state.stateName}</span>
                        </Tag>
                    ))}
                </div>
            )}
            {isLicensedStatesDirty && <Footer saveScope={AGENT_LICENSED_STATES_SAVE_SCOPE} />}
            <EditState open={isEditStateOpen} onCancel={() => setIsEditStateOpen(false)} />
        </div>
    );
};
